export const DOCUMENT_TYPES = {
  DNI: 1,
  NIE: 2,
  CIF: 3
};

export const STREET_TYPE = [
  { label: 'Aldea', value: 'AD' },
  { label: 'Alameda', value: 'AL' },
  { label: 'Autovía', value: 'AT' },
  { label: 'Autopista', value: 'AU' },
  { label: 'Avenida', value: 'AV' },
  { label: 'Barrio', value: 'BO' },
  { label: 'Barriada', value: 'BR' },
  { label: 'Calle', value: 'CL' },
  { label: 'Callejón', value: 'CJ' },
  { label: 'Camino', value: 'CM' },
  { label: 'Colonia', value: 'CO' },
  { label: 'Camping', value: 'CP' },
  { label: 'Carretera', value: 'CR' },
  { label: 'Caserio', value: 'CS' },
  { label: 'Cuesta', value: 'CT' },
  { label: 'Casas', value: 'CW' },
  { label: 'Dom. sin Indic. Direc.', value: 'DE' },
  { label: 'Finca', value: 'FI' },
  { label: 'Glorieta', value: 'GL' },
  { label: 'Grupo', value: 'GR' },
  { label: 'Gran Vía', value: 'GV' },
  { label: 'Lugar', value: 'LG' },
  { label: 'Manzana', value: 'MZ' },
  { label: 'Parcela', value: 'PA' },
  { label: 'Poblado', value: 'PB' },
  { label: 'Polígono', value: 'PG' },
  { label: 'Pasaje', value: 'PJ' },
  { label: 'Placeta', value: 'PL' },
  { label: 'Parque', value: 'PQ' },
  { label: 'Prolongación', value: 'PR' },
  { label: 'Paseo', value: 'PS' },
  { label: 'Portal', value: 'PT' },
  { label: 'Puerto', value: 'PU' },
  { label: 'Playa', value: 'PY' },
  { label: 'Plaza', value: 'PZ' },
  { label: 'Rambla', value: 'RB' },
  { label: 'Ronda', value: 'RD' },
  { label: 'Travesía', value: 'TR' },
  { label: 'Urbanización', value: 'UR' },
  { label: 'Vía', value: 'VI' },
  { label: 'Villa', value: 'VL' },
  { label: 'Zona', value: 'ZN' },
  { label: 'Domicil. Desconocido', value: 'ZZ' },
  { label: 'Apdo. Correos', value: 'AC' }
];

// Fixed data of the UI module
export const PROVINCES_DGT = [
  { label: 'Álava', value: 'araba', id: 1 },
  { label: 'Albacete', value: 'albacete', id: 2 },
  { label: 'Alicante', value: 'alacant', id: 3 },
  { label: 'Almería', value: 'almería', id: 4 },
  { label: 'Ávila', value: 'avila', id: 5 },
  { label: 'Badajoz', value: 'badajoz', id: 6 },
  { label: 'Baleares', value: 'illes balears', id: 7 },
  { label: 'Barcelona', value: 'barcelona', id: 8 },
  { label: 'Burgos', value: 'burgos', id: 9 },
  { label: 'Cáceres', value: 'cáceres', id: 10 },
  { label: 'Cádiz', value: 'cádiz', id: 11 },
  {
    label: 'Castellón',
    value: 'castelló de la plana',
    id: 12
  },
  {
    label: 'Ciudad Real',
    value: 'ciudad real',
    id: 13
  },
  { label: 'Córdoba', value: 'córdoba', id: 14 },
  {
    label: 'La Coruña',
    value: 'a coruña',
    id: 15
  },
  { label: 'Cuenca', value: 'cuenca', id: 16 },
  { label: 'Girona', value: 'girona', id: 17 },
  { label: 'Granada', value: 'granada', id: 18 },
  {
    label: 'Guadalajara',
    value: 'guadalajara',
    id: 19
  },
  {
    label: 'Guipuzcoa',
    value: 'gipuzkoa',
    id: 20
  },
  { label: 'Huelva', value: 'huelva', id: 21 },
  { label: 'Huesca', value: 'huesca', id: 22 },
  { label: 'Jaén', value: 'jaén', id: 23 },
  { label: 'León', value: 'león', id: 24 },
  { label: 'Lleida', value: 'lleida', id: 25 },
  { label: 'La Rioja', value: 'la rioja', id: 26 },
  { label: 'Lugo', value: 'lugo', id: 27 },
  { label: 'Madrid', value: 'madrid', id: 28 },
  { label: 'Málaga', value: 'málaga', id: 29 },
  { label: 'Murcia', value: 'murcia', id: 30 },
  { label: 'Navarra', value: 'biurrun', id: 31 },
  { label: 'Orense', value: 'ourense', id: 32 },
  { label: 'Asturias', value: 'asturias', id: 33 },
  { label: 'Palencia', value: 'palencia', id: 34 },
  {
    label: 'Las Palmas de G.C.',
    value: 'las palmas',
    id: 35
  },
  {
    label: 'Pontevedra',
    value: 'pontevedra',
    id: 36
  },
  {
    label: 'Salamanca',
    value: 'salamanca',
    id: 37
  },
  { label: 'Tenerife', value: 'santa cruz de tenerife', id: 38 },
  {
    label: 'Cantabria',
    value: 'cantabria',
    id: 39
  },
  { label: 'Segovia', value: 'segovia', id: 40 },
  { label: 'Sevilla', value: 'sevilla', id: 41 },
  { label: 'Soria', value: 'soria', id: 42 },
  {
    label: 'Tarragona',
    value: 'tarragona',
    id: 43
  },
  { label: 'Teruel', value: 'teruel', id: 44 },
  { label: 'Toledo', value: 'toledo', id: 45 },
  { label: 'Valencia', value: 'valència', id: 46 },
  {
    label: 'Valladolid',
    value: 'valladolid',
    id: 47
  },
  { label: 'Vizcaya', value: 'biscay', id: 48 },
  { label: 'Zamora', value: 'zamora', id: 49 },
  { label: 'Zaragoza', value: 'zaragoza', id: 50 },
  { label: 'Ceuta', value: 'ceuta', id: 51 },
  { label: 'Melilla', value: 'melilla', id: 52 }
];

export const PROVINCES = [
  { label: 'Álava', value: '01' },
  { label: 'Albacete', value: '02' },
  { label: 'Alicante', value: '03' },
  { label: 'Almería', value: '04' },
  { label: 'Ávila', value: '05' },
  { label: 'Badajoz', value: '06' },
  { label: 'Baleares', value: '07' },
  { label: 'Barcelona', value: '08' },
  { label: 'Burgos', value: '09' },
  { label: 'Cáceres', value: '10' },
  { label: 'Cádiz', value: '11' },
  { label: 'Castellón', value: '12' },
  { label: 'Ciudad Real', value: '13' },
  { label: 'Córdoba', value: '14' },
  { label: 'La Coruña', value: '15' },
  { label: 'Cuenca', value: '16' },
  { label: 'Girona', value: '17' },
  { label: 'Granada', value: '18' },
  { label: 'Guadalajara', value: '19' },
  { label: 'Guipuzcoa', value: '20' },
  { label: 'Huelva', value: '21' },
  { label: 'Huesca', value: '22' },
  { label: 'Jaén', value: '23' },
  { label: 'León', value: '24' },
  { label: 'Lleida', value: '25' },
  { label: 'La Rioja', value: '26' },
  { label: 'Lugo', value: '27' },
  { label: 'Madrid', value: '28' },
  { label: 'Málaga', value: '29' },
  { label: 'Murcia', value: '30' },
  { label: 'Navarra', value: '31' },
  { label: 'Orense', value: '32' },
  { label: 'Asturias', value: '33' },
  { label: 'Palencia', value: '34' },
  { label: 'Las Palmas de G.C.', value: '35' },
  { label: 'Pontevedra', value: '36' },
  { label: 'Salamanca', value: '37' },
  { label: 'Tenerife ', value: '38' },
  { label: 'Cantabria', value: '39' },
  { label: 'Segovia', value: '40' },
  { label: 'Sevilla', value: '41' },
  { label: 'Soria', value: '42' },
  { label: 'Tarragona', value: '43' },
  { label: 'Teruel', value: '44' },
  { label: 'Toledo', value: '45' },
  { label: 'Valencia', value: '46' },
  { label: 'Valladolid', value: '47' },
  { label: 'Vizcaya', value: '48' },
  { label: 'Zamora', value: '49' },
  { label: 'Zaragoza', value: '50' },
  { label: 'Ceuta', value: '51' },
  { label: 'Melilla', value: '52' }
];

export const APP_ROLES = {
  DRIVER_ROLE: 'DriverRole'
};

export const DEFAULT_LOCATION = {
  latitude: 40.41680239564228,
  longitude: -3.703803400000011,
  location: '',
  city: 'Madrid',
  country: 'ES',
  cp: '28001'
};

export const FILTER_POIS = [
  { label: 'Hospital', value: 'Hospital' },
  { label: 'Gasolinera', value: 'Gasolinera' },
  { label: 'Parking', value: 'Parking' },
  { label: 'Farmacia', value: 'Farmacia' }
];

export const TIME_FORMAT_CHARTS_LOCALE_ES = {
  decimal: ',',
  thousands: '.',
  grouping: [3],
  currency: ['€', ''],
  dateTime: '%a %b %e %X %Y',
  date: '%d/%m/%Y',
  time: '%H:%M:%S',
  periods: ['AM', 'PM'],
  days: ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'],
  shortDays: ['Lun', 'Mar', 'Mi', 'Jue', 'Vie', 'Sab', 'Dom'],
  months: [
    'Enero',
    'Febrero',
    'Marzo',
    'Abril',
    'Mayo',
    'Junio',
    'Julio',
    'Agosto',
    'Septiembre',
    'Octubre',
    'Noviembre',
    'Diciembre'
  ],
  shortMonths: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic']
};

export const TYPE_PRODUCT_COVERAGE = {
  coverage: ['050400', '050401'],
  flexibleUnlimited: ['050501'],
  unlimitedPass: ['050301']
};
